module.exports = __webpack_public_path__ + "static/image5-1fe4806eb0812dbc96f07c4b7c7926a1.jpg";